// extracted by mini-css-extract-plugin
export default {"prevArrow":"buddhism_prevArrow__HGSSP","nextArrow":"buddhism_nextArrow__n9+L2"};